import axios from 'axios';
import { req, alipayReq, jsonReq, reqPost, reqMyGet,reqPostString } from './axiosFun';
import Vue from 'vue';

// 整单售后
export const refundOrderApi = (params) => { return req("post", "/custom/xunyou/after_sale/api/refundAll", params) };

// 站内信未读条数接口
export const unreadCountApi = (data) => {
  return reqPost('/portal/mail/unreadCount', data)
};

// 站内信列表
export const tableDataInfoApi = (data) => {
  return reqPost('/portal/mail/list', data)
};

// 站内信内容接口
export const mailInfoApi = (data) => {
  return reqPost('/portal/mail/info', data)
};

// 清除未读接口
export const clearUnreadApi = (data) => {
  return reqPost('/portal/mail/clearUnread', data)
};



// /portal/user/info    传uid和userToken  个人信息
export const postInfo = (data) => {
  return reqPost('/portal/user/info', data)
};

// 售后原因
export const saleAfterReason = () => { return req("post","/custom/xunyou/after_sale/api/reasonList") };

// /portal/user/brandList  品牌列表 传uid
export const brandList = (params) => { return req("post","/portal/user/accountingCompanyList",params)};

// /api/chooseBrand   选择品牌，传uid，brand品牌
export const changeBrand = (params) => { return req("post","/portal/user/chooseAccountingCompany",params)};


//导出售后
export const exportAfter = (data) => {
  return reqPost('/custom/xunyou/after_sale/api/listExport', data)
};

// 清空购物车接口
export const removeShoppingCart = (params) => { return req("post", "/custom/xunyou/cart/api/shoppingCart/cartClear", params) };

// /custom/xunyou/api/cmbPay/applyForNote  还款调用聚合支付接口
export const applyForNote = (params) => { return req("post", "/custom/xunyou/api/cmbPay/applyForNote", params) };

export const getphoneCode = (data) => {
  return reqPost("/portal/nk/getCompanyByCreditCode", data)
};


// 重新发起售后  /custom/xunyou/after_sale/api/copy      参数bXyOasid  取消和拒绝状态下的售后才能重新发起
export const reAftersale = (params) => { return req("post","/custom/xunyou/after_sale/api/copy", params) };


// 授信还款列表
export const noteDetail = (params) => { return req("post", "/portal/pc/noteDetail/list", params) };

//白条明细
export const whiteDetail = (params) => { return req("post", "/portal/pc/noteDetail/flowList", params) };

// 余额流水导出：camp/custom/xunyou/user_balance_flow/api/export   参数跟上面一样
export const exportYE = (params) => { return req("post", "/custom/xunyou/user_balance_flow/api/export", params) };

// 导出
export const exportNodeDetail = (params) => { return req("post", "/portal/pc/noteDetail/export", params) };

// 导出白条明细
export const flowExport = (params) => { return req("post", "/portal/pc/noteDetail/flowExport ", params) };


// export const getOAphoneName = (params) => { return req("post", "/oa/getCompanyByCreditCode", params) };


// repayment/detailsList       批量还款详情 参数：detailsIds  多个id用英文逗号拼接 1,2,3,4
export const detailsList = (params) => { return req("get", `/custom/xunyou/white/app/note/api/repayment/detailsList?detailsIds=${params.detailsIds}&accountingCompanyCode=${params.accountingCompanyCode}`, params) };

// /portal/pc/orderListDetail  订单列表 订单详情接口，传oid，muid，userToken
export const orderListDetail = (params) => { return req("post", "/portal/pc/orderListDetail", params) };

//  portal/api/repair    维护网页开关，不用传参数 true代表维护中
export const repair = (params) => { return req("post", "/portal/api/repair", params) };

// 转账记录
export const getAccountsDetail = (params) => { return req("post", "/custom/xunyou/user_balance_flow/api/cmbTradeList", params) };

//余额充值
export const rechargeMoney = (params) => { return req("post", "/custom/xunyou/api/cmbPay/applyForRecharge", params) };

//获取ai地址的token
export const aiToken = (data) => {
  return reqPost('/portal/pc/baidu/accessToken', data)
};

// 获取商品规格
export const goodsAttributeList = (data) => {
  return reqPost("/custom/xunyou/bg_specification_details/api/getAttributeList", data)
};

// 下单获取商品信息
export const getSettleGoodsInfo = (data) => {
  return reqPost("/custom/xunyou/bg_specification_details/api/getPreOrderPrice", data)
};

// 聚合支付关闭
export const closeJH = (params) => { return req("post", "/custom/xunyou/api/cmbPay/close", params) };

// 聚合支付结果查询
export const resultJH = (params) => { return req("post", "/custom/xunyou/api/cmbPay/payQuery", params) };


// 聚合支付-- 申请支付，请求参数：uid，userToken，outTradeNo（订单号，跟支付宝请求保持一致），
export const applyJH = (params) => { return req("post", "/custom/xunyou/api/cmbPay/apply", params) };

// 订单复用商品
export const addGoodsToCar = (params) => { return req("post", "/custom/xunyou/cart/api/addOrderToCart", params) };

//地址代发添加地址
export const repPeoAddress = (data) => {
  return reqPost('/custom/xunyou/user_address/api/user_address/addNew', data)
};


//修改经销商名称和电话 custom/xunyou/user_address/api/addressEdit      said,phoneNumber,recipient
export const updateDealerInfo = (data) => {
  return reqPost('/custom/xunyou/user_address/api/addressEdit', data)
};


//预开票接口
export const preOpenInfo = (data) => {
  return reqPost('/portal/invoice/preOpenInfo', data)
};

export const getInvoiceOrderList = (params) => { return req("post", "/portal/invoice/orderList", params) };


export const exportInvoiceOrderList = (data) => {
  return reqPost('/portal/invoice/orderListExport', data)
};


export const alertInvoice = (data) => {
  return reqPost('/portal/invoice/redNotice', data)
};

export const redNoticeList = (params) => { return req("post", "/portal/invoice/redNoticeList", params) };

export const clearInvoice = (data) => {
  return reqPost('/portal/invoice/clearRedNotice', data)
};

export const postClearRedNotice= (data) => {
  return reqPost('/portal/invoice/clearRedNotice', data)
};

//开票详情
export const invoiceInfo = (data) => {
  return reqPost('/portal/invoice/info', data)
};

export const  timeApplyInvoice= (data) => {
  return reqPost('/portal/invoice/getOrderNumberByPayTime', data)
};

// portal/invoice/open   开票接口
export const openInvoice = (data) => {
  return reqPost('/portal/invoice/open', data)
};

// 发票还管理-列表
export const getInvoiceList = (params) => { return req("post", "/portal/invoice/list", params) };



// 经销商价格
export const updateDealerPrice = (params) => { return req('post', '/custom/xunyou/bg_specification_details/api/getSpecificationDetailById', params) }


//订单备注
export const setRemark = (data) => {
  return reqPost('/portal/pc/order/editOrderRemark', data)
};

//查某一分类的所有产品
export const getCalssGoods = (params) => { return req("post", "/custom/xunyou/commodity/api/commodityListNew", params) }; // stype  店铺类型（1.供货商|2.普通）

// sku列表
export const getskulist = (data) => {
  return reqPost('/portal/pc/specification/list', data)
};

// 批量申请退款
export const addBatch = (data) => {
  return reqPost('/custom/xunyou/after_sale/api/addBatch', data)
};

// 微信支付
export const alipayPcWX = (data) => {
  // return alipayReq("post", `${Vue.prototype.$baseUrl}/custom/xunyou/api/wx/wxpay`, params)   //线上使用
  //"http://122.51.226.11:18080/pay/wechat/scan"  `${Vue.prototype.$payUrl}/pay/wechat/scan`
  return reqPost('/custom/xunyou/api/wx/wxpay', data)   //自定义接口使用
};

// 支付宝授信还款
export const aliPayNote = (data) => {
  // return alipayReq("post", `${Vue.prototype.$baseUrl}/custom/xunyou/api/pay/aliPayNote`, params)  //线上使用
  return reqPost('/custom/xunyou/api/pay/aliPayNote', data)   //自定义接口使用
};


// 修改订单商品数量
export const editOrder = (data) => {
  return reqPost('/portal/pc/changeOrderCommodityNum', data)
};


// 支付宝支付
export const alipayPc = (data) => {
  // return alipayReq("post", `${Vue.prototype.$baseUrl}/custom/xunyou/api/pay/aliPay`, params)    //线上使用
  // "http://122.51.226.11:18080/pay/alipay/pc"  `${Vue.prototype.$payUrl}/pay/alipay/pc`
  return reqPost('/custom/xunyou/api/pay/aliPay', data)    //自定义接口使用
};

export const backMoney = (params) => {
  // return axios.get(`${Vue.prototype.$baseUrl}/custom/xunyou/api/pay/alipayRefund?out_trade_no=${params.out_trade_no}&refund_amount=${params.refund_amount}&out_request_no=${params.out_request_no}&refund_reason=${params.refund_reason}&goodsId=${params.goodsId}`)  //线上使用
  // return axios.get(`/camp/custom/xunyou/api/pay/alipayRefund?out_trade_no=${params.out_trade_no}&refund_amount=${params.refund_amount}&out_request_no=${params.out_request_no}&refund_reason=${params.refund_reason}&goodsId=${params.goodsId}`)  //测试环境
  return reqMyGet(`/custom/xunyou/api/pay/alipayRefund?out_trade_no=${params.out_trade_no}&refund_amount=${params.refund_amount}&out_request_no=${params.out_request_no}&refund_reason=${params.refund_reason}&goodsId=${params.goodsId}&accountingCompanyCode=${params.accountingCompanyCode}`)     //自定义接口使用
};

export const alipay = (params) => {
  // return axios.get(`${Vue.prototype.$baseUrl}/custom/xunyou/api/pay/alipay?outTradeNo=${params.outTradeNo}&subject=${params.subject}&totalAmount=${params.totalAmount}&notifyUrl=${params.notifyUrl}`) //线上使用
  // return axios.get(`/camp/custom/xunyou/api/pay/alipay?outTradeNo=${params.outTradeNo}&subject=${params.subject}&totalAmount=${params.totalAmount}&notifyUrl=${params.notifyUrl}`)     //测试环境
  return reqMyGet(`/custom/xunyou/api/pay/alipay?outTradeNo=${params.outTradeNo}&subject=${params.subject}&totalAmount=${params.totalAmount}&notifyUrl=${params.notifyUrl}&accountingCompanyCode=${params.accountingCompanyCode}`)     //自定义接口使用
};

//充值-新接口
export const aliPayForCZ = (data) => {
  // return reqMyGet(`/custom/xunyou/api/pay/alipay?outTradeNo=${params.outTradeNo}&subject=${params.subject}&totalAmount=${params.totalAmount}&notifyUrl=${params.notifyUrl}`)     //自定义接口使用
  return reqPost('/custom/xunyou/api/pay/aliPayForCZ', data)
};

// 商家入驻 申请表单
export const merchantForm = (data) => {
  return reqPostString("/portal/mercharnt_add", JSON.stringify(data))      //自定义接口使用
};

// 通过 立即购买按钮 跳转过来 下单的接口
export const immediatePlaceOrder = (data) => {
  return reqPostString("/portal/pc/immediatePlaceOrder_new", JSON.stringify(data))      //自定义接口使用
};


// 线下支付API
export const offlinePay = (params) => {
  return reqPost("/portal/offlinePay", JSON.stringify(params))      //自定义接口使用
};

//发送短信
export const sendSms = (params) => {
  // return axios.get(`${Vue.prototype.$baseUrl}/common/sendSms?TemplateCode=${params.TemplateCode}&phoneNumbers=${params.phoneNumbers}`)  //线上使用
  // return axios.get(`/camp/common/sendSms?TemplateCode=${params.TemplateCode}&phoneNumbers=${params.phoneNumbers}`)
  return reqMyGet(`/common/sendSms?TemplateCode=${params.TemplateCode}&phoneNumbers=${params.phoneNumbers}&accountingCompanyCode=${params.accountingCompanyCode}`)
};

// 提交订单
// export const addOrder = (params) => { return req("post", "/portal/add_order", params) };
export const addOrder = (data) => {
  //原来的接口地址-----start------
  // return axios.post(`${Vue.prototype.$baseUrl}/portal/pc/add_order`, params)   //线上使用
  // return axios.post(`/camp/portal/pc/add_order`, params)    //测试环境
  //原来的接口地址-----end------
  return reqPost("/portal/pc/add_order", data)      //自定义接口使用
};

// 查询店铺运费信息
export const getStoreFreight = (data) => {
  //原来的接口地址-----start------
  // return axios.post(`${Vue.prototype.$baseUrl}/portal/pc/getStoreFreight`, params)   //线上使用
  // return axios.post(`/camp/portal/pc/getStoreFreight`, params)   //测试环境
  //原来的接口地址-----end------
  return reqPost("/portal/pc/getStoreFreight", data)    //自定义接口使用
};

// axios.defaults.withCredentials=true
// 系统参数获取 /system/config/list 
export const systemConfig = (params) => { return req("get", "/portal/pc/api/url", params) };
// 系统参数公共方法
export const apiConfig = (params) => { return req("get", `/portal/pc/apiConfig?key=${params.key}&accountingCompanyCode=${params.accountingCompanyCode}`, params) };
// 系统参数 == 客户服务
export const apiHelpArticle = (params) => { return req("post", "/portal/pc/apiHelpArticle", params) };

// 查询IM消息盒子
export const messageInfo = (params) => { return req("get", "/im/messagebox", params) };

// 登录
export const login = (params) => { return req("post", "/api/login", params) };

// 注册 - 获取短信验证码
// export const sendSms = (params) => { return req("get", "/common/sendSms", params) };
// 获取默认图片
export const userImgList = (params) => { return req("post", "/custom/xunyou/dImageInformation/api/list", params) };


// 注册提交表达
export const register = (params) => { return req("post", "/custom/xunyou/api/registerPhone", params) };
// 注册协议
export const registerBook = (params) => { return req("post", "/custom/xunyou/protocol/api/list", params) };

//未登录  忘记密码 --- 
export const forgotPwd = (params) => { return req("post", "/custom/xunyou/api/forgotPwd", params) };
//不需要原密码直接修改用户密码 --- 
export const resetPassword = (params) => { return req("post", "/custom/xunyou/api/resetPassword", params) };

// 忘记密码 --- 检测账户是否存在
export const checkloginPhone = (params) => { return req("get", `/custom/xunyou/api/checkloginPhone?phone=${params.phone}&accountingCompanyCode=${params.accountingCompanyCode}`, params) };
// 忘记密码 --- 短信校验
export const querySendDetails = (params) => { return req("post", "/common/querySendDetails", params) };

// 修改支付密码
export const editPayPasw = (params) => { return req("post", "/portal/editPayPasw", params) };

// 为你推荐 /custom/xunyou/commodity/api/recommend/commoditylist
export const recommendFavorit = (params) => { return req("post", "/custom/xunyou/commodity/api/recommend/pcCommoditylist", params) };

// 首页数据
export const getPageIndex = (params) => { return req("get", `/custom/xunyou/api/getPage?id=${params.id}&muid=${params.muid}&accountingCompanyCode=${params.accountingCompanyCode}`, params) };

// 支付接口
// /custom/xunyou/api/pay/alipay
// export const alipay = (params) => { return req("get", "/custom/xunyou/api/pay/alipay", params) };

// export const alipay = (params) => { console.log(params,params.notifyUrl,'支付参数'); return axios.get(`${Vue.prototype.$baseUrl}/custom/xunyou/api/pay/alipay?outTradeNo=${params.outTradeNo}&subject=${params.subject}&totalAmount=${params.totalAmount}&notifyUrl=${params.notifyUrl}`)};
// 微信支付 回调接口
export const realipayPcWX = (params) => { return req("post", `/custom/xunyou/api/wx/QueryOrderStatus`, params) }; //"http://122.51.226.11:18080/pay/wechat/scan"  `${Vue.prototype.$payUrl}/pay/wechat/scan`

//  查询支付状态
export const payStatus = (params) => { return req("post", "/custom/xunyou/api/pay/alipayQuery", params) };

//  注册查询支付方式
export const getPayMode = (params) => { return req("get", "/custom/xunyou/api/getPayMode") };


export const xy_personvalue = (params) => { return req("post", "/custom/xunyou/xy_personvalue/api/deal", params) };

// 获取余额支付比例
export const getBalancePayProportion = (params) => { return req("get", "/portal/api/getBalancePayProportion", params) };

// 网银支付(快捷通)
export const getZtPay = (params) => { return req("post", "/portal/api/kjt/bank/pay", params) };

//支付包支付(快捷通)
export const getZtAlipayPcPay = (params) => { return req("post", "/portal/api/kjt/aggregate/pay", params) };
// 快捷通二维码支付状态
export const paycodeStatus = (params) => { return req("get", `/portal/api/kjt/pay/query?orderNum=${params.orderNum}&accountingCompanyCode=${params.accountingCompanyCode}`, params) };
// 快捷通 开关 接口
export const kjtEnable = (params) => { return req("get", `/portal/api/kjt/pay/enable?mIds=${params.mids}&cIds=${params.cIds}&accountingCompanyCode=${params.accountingCompanyCode}`, params) };
// 获取银行列表
export const kjtbankList = (params) => { return req("get", `/custom/xunyou/kjt/kjtbank/api/list`, params) };
// /custom/xunyou/kjt/kjtbank/api/list
// `${Vue.prototype.$baseUrl}/portal/pc/add_order`

/**
 * 订单管理-交易订单
 **/
// 红包查询
export const redEnvelope = (params) => { return req("post", "/custom/xunyou/api/redlist", params) };
// 红包领取
export const getredEnvelope = (params) => { return req("post", "/custom/xunyou/red_envelopes_record/api/add", params) };
// 我领取的红包y
export const getMyred = (params) => { return req("post", "/custom/xunyou/red_envelopes_record/api/list", params) };

// 商家入驻图片
export const pageConfigImg = (params) => { return req("post", "/custom/xunyou/page_config/api/list", params) };
// 商家入驻协议内容
export const agreementContent = (params) => { return req("post", "/custom/xunyou/mDescription/api/list", params) };

// 商家入驻欢迎页面下三个tabs
export const agreementThreelist = (params) => { return req("post", "/portal/agreementlist", params) };
// 商家入驻状态
export const getMercharntStep = (params) => { return req("post", "/portal/pc/getMercharntStep", params) };

// 商家入驻状态查询
export const getMercharntStatus = (params) => { return req("post", "/portal/pc/getMercharntStatus", params) }; //返回结果的状态1.审核中，2.审核通过
// 商家入驻是否支付保证金
export const payMargin = (params) => { return req("post", "/portal/pc/getMarginStatus", params) }; //返回结果的状态1.审核中，2.审核通过

//删除订单
export const delOrder = (params) => { return req("post", "/portal/pc/removeOrderCommodity", params) };



// export const merchantForm = (params) => { return req("post", "/portal/mercharnt_add", params) };
// export const merchantForm = (params) => { return req("post", "/portal/mercharnt_add", params) };

// 商家入驻下拉框 
// 店铺等级
export const slevelList = (params) => { return req("post", "/portal/slevelList", params) };
// 店铺分类
export const storeClasslist = (params) => { return req("post", "/custom/xunyou/classification/api/storeClasslist", params) };
// 店铺类目
export const leftmenu = (params) => { return req("get", "/portal/mainproduct", params) };
// 公司地址下拉框
export const area_list = (params) => { return req("post", "/portal/area_list", params) };
// 商家入驻付费清单
export const merchants_pay_list = (params) => { return req("post", "/portal/pc/merchants_pay_list", params) };
// 重新申请商家入驻
export const reApplyApi = (params) => { return req("post", "/portal/pc/reApply", params) };


// 查询保证金是否开启
export const openMargin = (params) => { return req("get", "/custom/xunyou/margin/api/queryMarginMoneySwitch", params) };

// 查询保证金
export const checkMargin = (params) => { return req("get", `/custom/xunyou/margin/api/queryMarginMoney/${params.bxscId}/${params.accountingCompanyCode}`, params) };

//新增保证金记录
export const addMargin = (params) => { return req("post", "/custom/xunyou/margin/api/add", params) };


// 商家入驻-合同签订及缴费
export const merchantpayMoney = (params) => { return req("post", "/custom/xunyou/merchant/api/merchantedit", params) };

// 品牌
export const brandListApi = (params) => { return req("post", "/portal/brandlist", params) };

// 查询购物车接口
export const shoppingCartlist = (params) => { return req("post", "/portal/cartlist", params) };
// 添加购物车
export const addShoppingCart = (params) => { return req("post", "/custom/xunyou/cart/api/shoppingCart/add", params) }; // 待检测
// 购物车中删除
export const shoppingCartDelete = (params) => { return req("post", "/custom/xunyou/cart/api/shoppingCart/remove", params) }; // 待检测
// 购物车数量计算
export const editCartNumber = (params) => { return req("post", "/custom/xunyou/cart/api/edit", params) };
// 记录购物车勾选状态
export const selectCarChecked = (params) => { return jsonReq("post", "/custom/xunyou/api/shoppingCart/checked", params) };

// 普通 -  商品列表  批发市场- 商品列表
export const commoditylist = (params) => { return req("post", "/custom/xunyou/commodity/api/pcCommoditylist", params) }; // stype  店铺类型（1.供货商|2.普通）
export const commoditylistSupplie = (params) => { return req("post", "/custom/xunyou/commodity/api/commoditylistSupplie", params) }; // stype  店铺类型（1.供货商|2.普通）
// 首页分类点击过去查询商品列表
export const commoditylistForSecondCategory = (params) => { return req("post", "/custom/xunyou/commodity/api/pcCommoditylistForSecondCategory", params) }; // stype  店铺类型（1.供货商|2.普通）
// 批发市场 == 首页分类点击过去查询商品列表
export const merchantCommoditylistForSecondCategory = (params) => { return req("post", "/custom/xunyou/commodity/api/merchantCommoditylistForSecondCategory", params) }; // stype  店铺类型（1.供货商|2.普通）

// 查询商品详情
export const commodityDetails = (params) => { return req("post", "/custom/xunyou/commodity/api/commoditylist_details_new", params) };
// 获取商品规格
export const getAttributelist = (params) => { return req("post", "/custom/xunyou/bg_specification_details/api/getAttributelist", params) };



// /custom/xunyou/bg_specification_details//getAttributelist
// 点击商品规格，获取相应的价格
export const getSpecificationDetail = (params) => { return req("post", "/custom/xunyou/bg_specification_details/api/getPcSpecificationDetail", params) };
// 点击商品规格，获取规格
export const getSpecificationselect = (params) => { return req("post", "/custom/xunyou/bg_specification_details/api/getSpecificationselect", params) }; //specificationId
// /custom/xunyou/bg_specification_details//getAttributelist
// 查询店铺评价
export const score = (params) => { return req("post", "/custom/xunyou/order_evaluation/api/score", params) };
// 商品面议时，联系我们接口
export const userFeedback = (params) => { return req("post", "/custom/system/user_feedback/api/add", params) };


// /api/getSpecificationselect

// 商品列表分类
export const categorylist = (params) => { return req("post", "/custom/xunyou/category/api/categorylist", params) };
// 商品详情页面
// export const categorylist = (params) => { return req("post", "/custom/xunyou/category/api/categorylist", params) };
// 商品咨询
export const goodsAdvice = (params) => { return req("post", "/custom/xunyou/advisory/api/list", params) };
// 商品咨询----提问
export const addgoodsAdvice = (params) => { return req("post", "/custom/xunyou/advisory/api/add", params) };
// 服务保障
export const serviceGuarantee = (params) => { return req("get", `/custom/xunyou/consumer_protection/api/apiListBymid?mid=${params.mid}&accountingCompanyCode=${params.accountingCompanyCode}`, params) };


// 批发市场- 商品列表 查询商品状态
// 0.未签约 1.审核中 2.签约通过 3.审核驳回 4.商品未签约 5.已经分销 6.一键分销
export const getDistStatus = (params) => { return req("post", "/portal/pc/getDistStatus", params) };
// 申请成为分销商
export const distributors_add = (params) => { return req("post", "/portal/pc/distributors_add", params) };
// 一键分销
export const WholesaleGoods_add = (params) => { return req("post", "/portal/pc/WholesaleGoods_add", params) };



// 订单详情页面（地址增删改查）
// 地址查询
export const addresslist = (params) => { return req("post", "/custom/xunyou/user_address/api/addresslist", params) };
//经销商地址
export const dealerAddresslist = (params) => { return req("post", "custom/xunyou/user_address/api/addresslist", params) };
// 增加地址
export const address_add = (params) => { return req("post", "/custom/xunyou/user_address/api/user_address/add", params) };
// 删除地址
export const address_remove = (params) => { return req("post", "/custom/xunyou/user_address/api/user_address/remove", params) };
// 修改地址
export const address_saveedit = (params) => { return req("post", "/custom/xunyou/user_address/api/user_address/saveedit", params) };

// 跳到下单详情页面前，掉这个接口
export const get_order = (params) => { return req("post", "/get_order", params) };
// 下单后显示订单
export const showorderList = (params) => { return req("post", "/portal/pc/api/orderList", params) };

//订单列表
export const orderList = (params) => { return req("post", "/portal/pc/orderListNew", params) };

// export const showorderList = (params) => { return req("post", "/portal/pc/orderVoList", params) };
// 查询订单详情
export const showorderDetail = (params) => { return req("post", "/portal/pc/orderDetails", params) };
// 下单时的校验
export const checkPay = (params) => { return req("post", "/portal/pc/checkPay", params) };

// 积分订单查询
export const pointList = (params) => { return req("post", "/custom/xunyou/xy_order/api/pointList", params) };


/** 我的订单 **/
// 搜索
export const searchOrder = (params) => { return req("post", "/custom/xunyou/user_address/api/user_address/saveedit", params) };
// 我的订单查询
export const orderLists = (params) => { return req("post", "/custom/xunyou/user_address/api/user_address/saveedit", params) };
// 立即支付
export const payFor = (params) => { return req("post", "/custom/xunyou/user_address/api/user_address/saveedit", params) };
// 退款
// export const backMoney = (params) => { return req("get", "/custom/xunyou/api/pay/alipayRefund", params) };
export const addbackMoney = (params) => { return req("post", "/custom/xunyou/after_sale/api/add", params) };
export const editbackMoney = (params) => { return req("post", "/custom/xunyou/after_sale/api/edit_after_sale", params) };
// 填写退货物流
export const returnDelivery = (params) => { return req("post", "/custom/xunyou/after_sale/api/returnDelivery", params) };
// 退款原因查询
export const getDictData = (params) => { return req("post", "/common/getDictData", params) };
// 退款列表
export const backMoneyList = (params) => { return req("post", "/custom/xunyou/after_sale/api/list", params) };
// /custom/xunyou/after_sale/api/list
// 撤销退款申请
export const remove_after_sale = (params) => { return req("post", "/custom/xunyou/after_sale/api/remove_after_sale", params) };

export const remove_after_cancelReject = (params) => { return req("post", "/custom/xunyou/after_sale/api/cancelReject", params) };


// 退款金额查询
export const returnAmount = (params) => { return req("get", `/custom/xunyou/after_sale/api/returnAmount?oid=${params.oid}&bxysid=${params.bxysid}&accountingCompanyCode=${params.accountingCompanyCode}`, params) };

// 取消订单
export const cancleOrderItem = (params) => { return req("post", "/portal/pc/cancelOrder", params) };
export const getLogistics = (params) => { return req("post", "/portal/pc/getLogistics", params) };
// 移除订单
export const removeOrderItem = (params) => { return req("post", "/portal/pc/removeOrder", params) };
// 确认收货
export const confirmRceiptItem = (params) => { return req("post", "/portal/order_End", params) };
export const confirmReplaceRceiptItem = (params) => { return req("post", "/custom/xunyou/return_form/api/buyerReceipt", params) };
// 物流查询
export const kuaidi100 = (params) => { return req("get", `/custom/xunyou/api/kuaidi/kuaidi100?tracking_num=${params.tracking_num}&logistics_name=${params.logistics_name}&oid=${params.oid}&accountingCompanyCode=${params.accountingCompanyCode}`, params) };


// 查看订单详情
export const orderDetailItem = (params) => { return req("post", "/custom/xunyou/user_address/api/user_address/saveedit", params) };

/** 关注中心 **/
// 我的足迹
export const footprint_list = (params) => { return req("post", "/custom/xunyou/footprint/api/footprint_list", params) };
// 商品/店铺收藏
export const collection_list = (params) => { return req("post", "/custom/xunyou/collectionMG/api/pcCollection_list", params) }; //type:1:商品；2：店铺；
// 添加收藏
export const addCollection = (params) => { return req("post", "/custom/xunyou/collectionMG/api/addCollection", params) }; //type:1:商品；2：店铺；
// 取消收藏
export const removeCollection = (params) => { return req("post", "/custom/xunyou/collectionMG/api/removeCollection", params) }; //type:1:商品；2：店铺；

/** 个人中心 **/
// 我的信息
export const userDetails = (params) => { return req("get", `/portal/userDetails/${params.userId}/${params.accountingCompanyCode}`, params) };
//账户信息编辑
export const editUser = (params) => { return req("post", '/portal/editUser', params) };
//已登录 -- 修改密码 
export const resetPwd = (params) => { return req("post", "/custom/xunyou/api/resetPwd", params) };

/** 财产中心 */
export const integralList = (params) => { return req("post", "/custom/xunyou/integral/api/list", params) };


// 交易订单-s删除交易订单
// export const OrderDelete = (params) => { return axios.delete("/api/Order/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
/**
 * 首页
 */

// 顶部热门搜索
export const hot_search = (params) => { return req("post", "/custom/xunyou/api/hot_search", params) };
// 顶部默认搜索
export const search_list = (params) => { return req("post", "/custom/xunyou/api/search_list", params) };

//轮播图
export const swiperList = (params) => { return req("post", "/custom/xunyou/promotion/api/swiperlist", params) };

//热门分类图
export const categoryHotList = (params) => { return req("post", "/portal/storeCategoryHot_list", params) };

//菜单
export const navList = (params) => { return req("post", "/portal/navlist", params) };

//左侧菜单
export const leftMenuList = (params) => { return req("get", "/portal/leftmenu", params) };

// 通知
export const noticeList = (params) => { return req("post", "/custom/xunyou/api/articleList", params) };

/**
 * 店铺街
 */
//店铺列表
export const storerList = (params) => { return req("post", "/portal/pc/pcMerchantlist", params) };

//店铺列表
export const merchantlistSupplie = (params) => { return req("post", "/portal/pc/merchantlistSupplie", params) };

// 查询店铺的用户管理
export const imUserID = (params) => { return req("post", "/portal/pc/getImUserID", params) };

export const imFriends = (params) => { return req("post", "/custom/xunyou/im_friends/api/add", params) };
// 店铺页面 - 查询店铺轮播图
export const storeSwiperList = (params) => { return req("post", "/custom/xunyou/store_mg/store/store_info/api/list", params) };
// 店铺页面 - 查询店铺分类(內)列表
export const storeCategory = (params) => { return req("post", "/custom/xunyou/sort/api/list", params) };


/** 支付中心 */
// 交易流水
export const payList = (params) => { return req("post", "/custom/xunyou/user_balance_flow/api/payList", params) };
// 余额流水查询
export const balanceTurnover = (params) => { return req("post", "/custom/xunyou/user_balance_flow/api/list", params) };
// 点击充值 recharge
export const recharge = (params) => { return req("post", "/portal/pc/merchantlist", params) };

/** 用户中心 */
// 账号绑定-实名认证
export const queryUserStatus = (params) => { return req("post", "/portal/queryUserStatus", params) };
// 账号绑定-手机绑定
export const bindingPhone = (params) => { return req("post", "/portal/bindingPhone", params) };
// 账号绑定-邮箱绑定
export const bindingEmail = (params) => { return req("post", "/portal/bindingEmail", params) };
//  账号绑定-发送邮箱验证码
export const sendEmail = (params) => { return req("get", `/common/sendEmail?email=${params.email}`, params) };
//  账号绑定-邮箱验证码校验
export const vEmail = (params) => { return req("post", '/common/vEmail', params) };
// 账号绑定-实名认证
export const authentication = (params) => { return req("post", "/portal/authentication", params) };
// 提现
export const alipayTransfer = (params) => { return alipayReq("get", `${Vue.prototype.$baseUrl}/custom/xunyou/api/pay/alipayTransfer`, params) };


/**  客户服务  * */
// 文章分类列表
export const article_category_list = (params) => { return req("post", "/portal/article_category_list", params) };
// 文章（和公告）列表接口
export const helpArticle_list = (params) => { return req("post", "/portal/helpArticle_list", params) };
// 文章（和公告）详情
export const helpArticle_details = (params) => { return req("get", `/portal/helpArticle_details/${params.articleId}/${params.accountingCompanyCode}`, params) };

//pc首页底部文字列表2021-07-03
export const bottom_article_list = (params) => { return req("post", "/portal/bottom_article_list", params) };
// 个人账户汇总
export const getUserPay = (params) => { return req("get", `/custom/xunyou/api/getUserPay/${params.userId}/${params.userToken}/${params.accountingCompanyCode}`, params) };



/** 评论 */
// 待评论列表
export const evaluateCommodityList = (params) => { return req("post", "/custom/xunyou/evaluation/api/evaluateCommodityList2", params) };
// 评论列表
export const commentList = (params) => { return req("post", "/custom/xunyou/evaluation/api/list", params) };
// 发表评论
export const postComment = (params) => { return req("post", `/custom/xunyou/evaluation/api/add`, params) };
// 回复评论
export const replayComment = (params) => { return req("post", `/custom/xunyou/deal_order_evaluation_reply/api/add`, params) };
// 删除评论
export const deleteComment = (params) => { return req("post", `/custom/xunyou/evaluation/api/remove`, params) };

// 商品评价详情
export const findEvaluation = (params) => { return req("post", "/custom/xunyou/evaluation/api/findEvaluation", params) };

/** 资金 */
// 充值卡校验是否存在
export const checkcard = (params) => { return req("post", "/portal/checkcard", params) };
// 充值卡充值
export const rechargeCard_recharge = (params) => { return req("post", "/portal/rechargeCard_recharge", params) };
// 充值卡流水列表
export const recharge_card_turnover = (params) => { return req("post", "/custom/xunyou/recharge_card_turnover/api/list", params) };
// // 余额支付API
export const balancePay = (params) => { return req("post", "/portal/balancePay", params) };
// // 白条授信支付API
export const repaymentPay = (params) => { return jsonReq("post", "/custom/xunyou/white/app/note/api/pay/repayment", params) };



export function setCookie(c_name, value, expiredays) {

  var exdate = new Date();

  exdate.setDate(exdate.getDate() + expiredays);

  document.cookie = c_name + "=" + value + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());

};

// 查询凭证信息
export const getVoucherByOid = (params) => { return req("post", "/portal/getVoucherByOid", params) };
// 上传凭证信息
export const submitPaymentVoucher = (params) => { return req("post", "/portal/submitPaymentVoucher", params) };

// 混合支付
export const balancePayMax = (params) => { return req("post", "/portal/balancepay_max", params) };

/* 积分商城 */
export const presentlist = (params) => { return req("post", "/custom/xunyou/points_exchange/api/presentlist", params) };

/* 限时折扣 */
// activityTypeId=2 2折扣 6秒杀
export const activityCommodityList = (params) => { return req("post", "/custom/xunyou/commodity/api/activityCommodityList", params) };

/* 秒杀 */
export const seckillCommodityList = (params) => { return req("post", "/custom/xunyou/commodity/api/seckillCommodityList", params) };
// /center/custom/xunyou/commodity/api/seckillCommodityList

/** 首页 */
// 装修接口
// export const getPage = (params) => {return req("get", `/custom/xunyou/api/getPage?id=${params.id}`, params) };
export const getPage = (params) => { return req("get", `/portal/pc/getPcPage?id=${params.id}&accountingCompanyCode=${params.accountingCompanyCode}`, params) };

/* 改造后的接口 */
// 商品列表
export const commodities = (params) => { return req("get", "/center/rest-apis/commodities", params) };

/** 文章评价 */
//新增评论接口
export const addChat = (params) => { return req("post", "/custom/xunyou/context/api/add", params) }
// 查询评论列表
export const getChat = (params) => { return req("post", "/custom/xunyou/context/api/list", params) }
// 渲染店铺入驻协议
export const shopPass = (params) => { return req("post", "/custom/xunyou/description/api/list", params) }
// 版权名称可配
export const copyRight = (params) => { return req("post", "/custom/xunyou/information/api/list", params) }
// 自定义图片设置
export const setImage = (params) => { return req("post", "/custom/xunyou/imageInformation/api/list", params) }
// 查询快递公司接口 /custom/xunyou/express_delivery/api/listlist
export const getCompany = (params) => { return req("post", `/custom/xunyou/express_delivery/api/${params.id}/${params.accountingCompanyCode}`, params) }
// 查询平台所有的快递公司
export const getAllCompany = (params) => { return req("post", `/custom/xunyou/express_delivery/api/list`, params) }
// 删除足迹
export const removefoot = (params) => { return req('post', '/custom/xunyou/footprint/api/removeFootprint', params) }

//覆盖规格价格
export const coveragePrice = (params) => { return req('post', '/custom/xunyou/bg_specification_details/api/getSpecificationDetailById', params) }
//白条支付
export const notePay = (params) => { return jsonReq('post', '/custom/xunyou//white/app/note/pay/repayment', params) }
//申请返修
export const applyRework = (params) => { return req('post', '/custom/xunyou/return_form/api/edit', params) }

// 账期白条
export const ModuleGet = (params) => { return req("get", `/custom/xunyou/white/app/note/api/lines?type=${params.type}&userId=${params.userId}&userToken=${params.userToken}&accountingCompanyCode=${params.accountingCompanyCode}`) };
export const getDetailed = (params) => { return req("get", `/custom/xunyou/white/app/note/api/running/record?id=${params.id}&pageNum=${params.pageNum}&pageSize=${params.pageSize}&userToken=${params.userToken}&muid=${params.muid}&accountingCompanyCode=${params.accountingCompanyCode}`) };
export const getBill = (params) => { return req("get", `/custom/xunyou/white/app/note/api/repayment/record?id=${params.id}&pageNum=${params.pageNum}&pageSize=${params.pageSize}&muid=${params.muid}&userToken=${params.userToken}&accountingCompanyCode=${params.accountingCompanyCode}`) };
export const getInfo = (params) => { return req("post", `/custom/xunyou/white/app/note/api/apply`, params) };
export const listDetails = (params) => { return req("get", `/custom/xunyou/purchaser/inquiry/inquiry/details/list`, params) };
export const getRepayment = (params) => {
  return req("get", `/custom/xunyou/white/app/note/api/bill?id=${params.id}&pageNum=${params.pageNum}&pageSize=${params.pageSize}&userToken=${params.userToken}&muid=${params.muid}&orderNumber=${params.orderNumber}&beginCreateTime=${params.beginCreateTime}&endCreateTime=${params.endCreateTime}&status=${params.status}&beginDeadlineTime=${params.beginDeadlineTime}&endDeadlineTime=${params.endDeadlineTime}&accountingCompanyCode=${params.accountingCompanyCode}`, params)
};
export const getDetails = (params) => { return req("get", `/custom/xunyou/white/app/note/api/repayment/details?detailsId=${params.detailsId}&accountingCompanyCode=${params.accountingCompanyCode}`, params) };
export const payDetails = (params) => { return jsonReq("post", `/custom/xunyou/white/app/note/api/apply/repayment`, params) };
export const getTypes = (params) => { return req("get", `/custom/xunyou/white/app/note/api/apply/details?type=${params.type}&userId=${params.userId}&accountingCompanyCode=${params.accountingCompanyCode}`, params) };
// 快速下单
// export const quicklyModuleGet = (params) => { return req(`/custom/xunyou/commodity/api/pcCommoditylist?id=` + params) };
export const shoppingCart = (params) => { return req(`/custom/xunyou/cart/api/shoppingCart/addList`, params) };

export const getWhiteTypeInfo = (params) => { return req("get", `/custom/xunyou/white/app/note/api/info?userId=${params.userId}&accountingCompanyCode=${params.accountingCompanyCode}`) };

// 询价

// 询价
export const pcCommoditylist = (params) => { return req("post", `/custom/xunyou/commodity/api/recommend/pcCommoditylist`, params) };

// 退款查询运费
export const getTranFee = (params) => { return req("post", `/custom/xunyou/after_sale/api/getTranFee`, params) };

// 注册 -- 渠道

export const getSourceChannels = (params) => { return req('get', '/custom/xunyou/api/getSourceChannels', params) }
// 添加子账号
export const addChildAccount = (params) => { return req('post', '/custom/xunyou/api/addChildAccount', params) }
//子账号列表
export const getChildAccount = (params) => { return req('get', `/custom/xunyou/api/getChildAccount?parentAccId=${params.parentAccId}&pageNum=${params.pageNum}&pageSize=${params.pageSize}&accountingCompanyCode=${params.accountingCompanyCode}`, params) }
export const isEnableChildAccount = (params) => { return req('post', '/custom/xunyou/api/isEnableChildAccount', params) }

export const removeChildAccount = (params) => { return req('post', '/custom/xunyou/api/removeChildAccount', params) }

export const editChildAccount = (params) => { return req('post', '/custom/xunyou/api/editChildAccount', params) }


export const searchCompletion = (params) => { return req('post', '/custom/xunyou/commodity/api/searchCompletion', params) }

export const userCashBackInfo = (params) => { return req('post', '/custom/xunyou/cash_back/api/userCashBackInfo', params) }
// 返利统计
export const countUserCashBack = (params) => { return req('post', '/custom/xunyou/cash_back/api/countUserCashBack', params) }


// 发票相关接口

export const invoiceAdd = (params) => { return req('post', '/custom/xunyou/user_invoice/api/add', params) }
// 获取发票地址
export const getList = (params) => { return req('post', '/custom/xunyou/user_invoice/api/getList', params) }
export const editDefault = (params) => { return req('post', '/custom/xunyou/user_invoice/api/editDefault', params) }

//删除发票
export const remove = (params) => { return req('post', '/custom/xunyou/user_invoice/api/remove', params) }

export const userInvoiceAdd = (params) => { return req('post', '/custom/xunyou/invoice/api/add', params) }


// 新增发票地址
export const addUserInvoice = (params) => { return req('post', '/custom/xunyou/user_invoice/api/add', params) }

// 修改发票地址
export const userInvoiceEdit = (params) => { return req('post', '/custom/xunyou/user_invoice/api/edit', params) }


// 新建发票地址
export const getUserCashBack = (params) => { return req('post', '/custom/xunyou/cash_back/api/getUserCashBack', params) }

export const importTemplateOrder = () => { return req('get', '/portal/pc/order/exportTemplate') }

// 购物车页面下载先获取文件名
export const importTemplateCart = () => { return req('get', '/portal/pc/importTemplateCart') }

// export const download = (name) => { return req('get', `/common/download?fileName=${name}&delete=true`) }

// 订单页 请求发票图片
export const getInvoiceImage = (params) => { return req('post', `/custom/xunyou/invoice/api/list`, params) }

// 订单页 请求发票图片
export const getsonOrderList = (params) => { return req('post', `/portal/pc/api/orderList`, params) }
export const getSalesmanUserList = (params) => { return req('post', `/portal/pc/getSalesmanUserList`, params) }


export const applyPriceChange = (params) => { return req('post', `/portal/pc/applyPriceChange`, params) }


//导出订单订单列表
export const exportOrderList = (data) => { return reqPost(`/portal/pc/api/orderListExport`, data) }

//导出白条
export const exportbt = (params) => {
  return req(
    "get", `/custom/xunyou/white/app/note/api/bill/export?id=${params.id}&pageNum=${params.pageNum}&pageSize=${params.pageSize}&userToken=${params.userToken}&muid=${params.muid}&orderNumber=${params.orderNumber}&beginCreateTime=${params.beginCreateTime}&endCreateTime=${params.endCreateTime}&status=${params.status}&beginDeadlineTime=${params.beginDeadlineTime}&endDeadlineTime=${params.endDeadlineTime}&accountingCompanyCode=${params.accountingCompanyCode}`, params)
};

//  接口名称 ：totalOrderDetails   参数：oids
export const totalOrderDetails = (params) => { return req("post", "/portal/pc/totalOrderDetails", params) };


//  接口名称 ：  新我的订单接口新我的订单接口
export const orderListNew = (params) => { return req("post", "/portal/pc/orderListNew ", params) };

// portal/pc/orderDetailsPage   订单详情分页  查询条件：code(SKU), commodityName(商品名称)
export const orderDetailsPage = (params) => { return req("post", "/portal/pc/orderDetailsPage", params) };

//订单详情汇总数据
export const orderDetailsInfo = (params) => { return req("post", "/portal/pc/orderDetailsInfo", params) };

//返利总列表
export const userCashBackList = (data) => {
  return reqPost("/custom/xunyou/cash_back/api/userCashBackList", data)
};

export const userCashBackOutList = (data) => { return req("post", "/custom/xunyou/cash_back/api/userCashBackOutList", data) };





// WEBPACK FOOTER //
// ./src/api/xunyou.js